import React, { FC, SyntheticEvent, useMemo } from 'react';
import { Icon } from '@cld/icon';
import Typography from '@cld/typography';
import { CollapsibleContent, InnerContent, InvisibleCheckbox, Label, Root } from './CollapsibleSectionIE11.styled';
import { SectionProps } from './Section';

/** Collapsible section component - Fallback for IE11 */
export const CollapsibleSectionIE11: FC<SectionProps> = ({ children, title, open, onToggle, className, horizontalPadding, verticalPadding }) => {
  const onChange = useMemo(() => {
    if (!onToggle) {
      return undefined;
    }

    return (event: SyntheticEvent<HTMLInputElement>) => onToggle(event.currentTarget.checked);
  }, [onToggle]);

  return (
    <Root className={className}>
      <InvisibleCheckbox id="collapsible" type="checkbox" checked={open} onChange={onChange} />
      <Label htmlFor="collapsible" data-test="section-label">
        <Typography size="xs" type="lowContrast">
          {title}
        </Typography>
        <Icon name="keyboardArrowDown" size="xs" />
      </Label>
      <CollapsibleContent data-test="section-content">
        <InnerContent horizontalPadding={horizontalPadding} verticalPadding={verticalPadding}>{children}</InnerContent>
      </CollapsibleContent>
    </Root>
  );
};
